module.exports = __webpack_public_path__ + "static/media/article-evacuate.7ebf0665.png";